import PropTypes from "prop-types";
import { useState } from "react";

import { MdShareLocation, MdBed } from "react-icons/md";
import {
  BiBuildingHouse,
  BiCalendar,
  BiArea,
  BiTimeFive,
} from "react-icons/bi";

const LeftPanelCard = ({ item }) => {
  const [compareCheckbox, setCompareCheckbox] = useState(false);
  const handleCheckBox = () => {
    setCompareCheckbox(!compareCheckbox);
  };
  return (
    <>
      <div className="lpContent-card mb-2">
        <div className="lpContent-card-desc px-2 ">
          <div className="Lp-items">
            <div className="">
              <MdShareLocation className="gray" />
              <span className="f-Bold f-12px lightGray px-1">{item.zone}</span>
            </div>
            <div className="">
              <BiBuildingHouse className="gray" />
              <span className="f-Bold f-12px lightGray px-1">
                {item.buildingType}
              </span>
            </div>
            <div className="">
              <BiCalendar className="gray" />
              <span className="f-Bold f-12px lightGray px-1">{`${item.lifeTime} ساله`}</span>
            </div>
            <div className="">
              <MdBed className="gray" />
              <span className="f-Bold f-12px lightGray px-1">{`${item.beds} خوابه`}</span>
            </div>
            <div className="">
              <BiArea className="gray" />
              <span className="f-Bold f-12px lightGray px-1">{`${item.area} متر`}</span>
            </div>
            <div className="">
              <span className="f-Black f-10px gray">رهن: </span>
              <span className="f-Bold f-12px lightGray">{`${item.mortgage} میلیارد تومان`}</span>
            </div>
            <div className="mb-2">
              <span className="f-Black f-10px gray">اجاره: </span>
              <span className="f-Bold f-12px lightGray">{`${item.rent} میلیون تومان`}</span>
            </div>
          </div>

          <div className="lpContent-card-imgs-btns p-1">
            {compareCheckbox ? (
              <div onClick={handleCheckBox} className="m-btn-checkBox-checked ">
                <input type="checkbox" value="" id="compareCheckBox" checked />
                <label className="f-10px f-Medium mb-0" htmlFor="flexCheckDefault">
                  مقایسه
                </label>
              </div>
            ) : (
              <div onClick={handleCheckBox} className="m-btn-checkBox ">
                <input type="checkbox" value="" id="compareCheckBox" />
                <label className="f-10px f-Medium mb-0" htmlFor="flexCheckDefault">
                  مقایسه
                </label>
              </div>
            )}

            <button className="px-1 f-10px m-btn m-btn-red f-Medium">
              اطلاعات بیشتر
            </button>
          </div>
          {/* <div className="Lp-cta">
            <div>
              <BiTimeFive className="gray" />
              <span className="f-Bold f-10px lightGray px-1 nowrap">{`${item.updateTime} ساعت پیش`}</span>
            </div>
            <a className="f-Bold f-10px red  nowrap m-0" href={item.backLink}>
              مشاهده آگهی در دیوار
            </a>
          </div> */}
        </div>
        <div className="lpContent-card-img ">
          <div className="lpContent-card-img-container">
            <img src={item.imgUrl} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

LeftPanelCard.propTypes = {
  item: PropTypes.object,
};
LeftPanelCard.defaultProps = {
  item: {},
};

export default LeftPanelCard;
